import './style.scss'
import React from 'react'
import { Box, UIProps } from 'src/componentv2/Base/ui'

export interface RectangleProps extends UIProps {
    children?: React.ReactNode
    onClick?: () => void
}

export const Rectangle: React.FC<RectangleProps> = ({
                                                        children, className = '', ...rest
                                                    }) => (
    <Box className={`rectangle ${className}`} {...rest}>
        {children}
    </Box>
)

export default Rectangle